import React from 'react';

import { useGetIssueTypeFields } from '../../services/useGetIssueTypeFields';
import { useSetOptionsColumns } from '../../utils/useSetOptionsColumns';
import { useInitMappings } from '../../utils/useInitMappings';
import { useMapTableToIssues } from '../../utils/useMapTableToIssues';
import { useHandleCloseAndAddIssuesToPage } from '../../services/useCloseAndAddIssuesToPage';
import { BulkConfigureView } from '../bulk-work-create-configure/BulkConfigureView';
import { BulkCreateDefaultView } from '../bulk-work-create-list/BulkCreateDefaultView';

import { BulkEditIssueView } from './BulkEditIssueView';
import { BulkCreateFlagsContainer } from './BulkCreateFlagsContainer';

export const BulkNavigationContainer = ({ onClose }: { onClose: () => void }) => {
	useGetIssueTypeFields();
	useSetOptionsColumns();
	useInitMappings();
	useMapTableToIssues();
	useHandleCloseAndAddIssuesToPage(onClose);

	return (
		<>
			<BulkCreateDefaultView onClose={onClose} />
			<BulkConfigureView closePanel={onClose} />
			<BulkEditIssueView />
			<BulkCreateFlagsContainer />
		</>
	);
};
